<template>
  <div id="app">
    <CalculatorDesign :min="0" :max="100" :step="5" />
  </div>
</template>

<script>
import CalculatorDesign from "./components/Calculator.vue";

export default {
  name: "App",
  components: {
    CalculatorDesign,
  },
};
</script>

<style>
#app {
}
</style>
